import React from 'react';
import Layout from '../../../components/layout/Layout';
import PageNotFound from '../../../components/404/PageNotFound';
import Typography from '../../../components/Typography/Typography';

export default function NotFound() {
  return (
    <div>
      <Layout className="mx-auto flex justify-center object-center">
        <PageNotFound />

        <Typography size="text-6xl" sampletext="404" />
      </Layout>
    </div>
  );
}
